module.exports = __webpack_public_path__ + "static/7-47e481446c19b56a7c4e6d0f5284790d.jpg";